// extracted by mini-css-extract-plugin
export default {"magneticButton":"MagneticButton_magneticButton__BhZLF","content":"MagneticButton_content__2i8bB"};